<template>
    <v-menu
        content-class="round-card"
        transition="slide-y-transition"
        min-width="350"
        max-width="350"
		offset-y
		nudge-left="200"
        v-model="showDaily">
        <template v-slot:activator="{ on }" v-if="!hideActivator">
            <v-btn v-on="on" icon>
                <v-icon :class="$eventBusUtility.iconAppBarColor">alarm</v-icon>
            </v-btn>
		</template>

        <v-sheet height="400">
            <v-calendar v-if="load"
                color="primary"
                type="day"
                first-interval="8"
                interval-count="12"
                :interval-format="formatDay"
                :events="events">            
            </v-calendar>
        </v-sheet>

    </v-menu>
</template>
<script>
    export default {
        name: 'daily-timecard',
        props: {
            hideActivator: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showDaily: false,
                load: false,
                events: []
            }
        },

        watch: {
            showDaily: {
                handler() {
                    this.getDailyTimecard()
                }
            }
        },

        methods: {
            formatDay(time) {
                return time.time
            },

            getDailyTimecard() {
                this.axios.post('daily-timecards/', 
                    {
                        filters: {
                            start_date: moment().format('YYYY-MM-DD'),
                        }
                    }).then(response => {
                        // get body data
                        this.events = response.data.data
                        this.load = true
                }, response => {
                    // error callback
                })                
            }
        },

    }
</script>